import React from "react";

interface Props {
  activeTab: string;
  setActiveTab: (tab: any) => void;
  orderStats: { total: number; pending: number; completed: number; cancelled: number };
  totalRecords: number;
  getBgClass: () => string;
  themeRingColor: string;
  themeTextColor: string;
}

const OrderTabs: React.FC<Props> = ({ activeTab, setActiveTab, orderStats, totalRecords, getBgClass, themeRingColor, themeTextColor }) => {
  const tabs = [{ key: "pending", label: "Pending Orders", count: orderStats.pending }];

  return (
    <div className="w-full">
      {/* Mobile: Horizontal Scroll */}
      <div className="flex gap-2 overflow-x-auto scrollbar-hide lg:flex-wrap lg:overflow-visible lg:pb-0">
        {tabs.map((tab) => (
          <div
            key={tab.key}
            className={`flex items-center text-lg justify-between font-semibold gap-3 px-2 py-2 rounded-xl capitalize ease-in-out min-w-max`}>
            <div className="flex flex-col items-start gap-1">
              <span className="text-xl font-bold sm:text-lg whitespace-nowrap">{tab.label}</span>
            </div>

            {/* Count Badge */}
            <span
              className={`px-2.5 py-1.5 rounded-lg text-sm font-bold min-w-10 text-center transition-colors duration-200 border-2 shadow-sm
            `}
            >
              {totalRecords}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OrderTabs;
